import { c as _c } from "react/compiler-runtime";
import { IcoFileText16 } from '@onefootprint/icons';
import { LinkButton } from '@onefootprint/ui';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DocumentItem from '@/entity/components/content/components/document-item';
import { useDecryptForm } from '@/entity/components/decrypt-form';
import type { WithEntityProps } from '@/entity/components/with-entity';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import useDocumentField from '@/entity/hooks/use-document-field';
import type { TransformedDocument } from '@/entity/hooks/use-documents';
export type DocumentFieldsetProps = WithEntityProps & {
  documents: TransformedDocument[];
};
export const DOCUMENTS_ID = 'documents';
const DocumentFieldset = t0 => {
  const $ = _c(37);
  const {
    entity,
    documents
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const decryptControls = useDecryptControls();
  const decryptForm = useDecryptForm();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== decryptForm.control) {
    t3 = {
      control: decryptForm.control,
      name: "documentKinds",
      defaultValue: t2
    };
    $[2] = decryptForm.control;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const selectedFields = useWatch(t3);
  let t4;
  if ($[4] !== entity) {
    t4 = {
      entity
    };
    $[4] = entity;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const documentField = useDocumentField(t4);
  let t5;
  if ($[6] !== documentField || $[7] !== documents) {
    let t6;
    if ($[9] !== documentField) {
      t6 = document$0 => documentField.getProps(document$0).canSelect;
      $[9] = documentField;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = documents.filter(t6);
    $[6] = documentField;
    $[7] = documents;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const selectableFields = t5;
  const hasSelectableFields = selectableFields.length > 0;
  const allSelected = selectedFields.length === selectableFields.length;
  const shouldShowSelectAll = decryptControls.step === "selecting-fields" && hasSelectableFields;
  const defer = _temp2;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = async () => {
      const documentKinds = Array.from(document.querySelectorAll("input[name=\"documentKinds\"]"));
      for (const checkbox of documentKinds) {
        checkbox.click();
        await defer();
      }
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleToggle = t6;
  let t7;
  if ($[12] !== t) {
    t7 = t(_temp3);
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IcoFileText16 />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t(_temp4);
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <div className="flex items-center gap-2">{t8}<h2 className="text-label-2">{t9}</h2></div>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== allSelected || $[20] !== shouldShowSelectAll || $[21] !== t) {
    t11 = shouldShowSelectAll && <LinkButton onClick={handleToggle}>{allSelected ? t(_temp5) : t(_temp6)}</LinkButton>;
    $[19] = allSelected;
    $[20] = shouldShowSelectAll;
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <header className="flex justify-between px-4 py-2 border-b border-solid bg-secondary border-tertiary rounded-t-md">{t10}{t11}</header>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== documents || $[27] !== entity) {
    let t14;
    if ($[29] !== entity) {
      t14 = document_0 => <DocumentItem document={document_0} entity={entity} key={document_0.startedAt} value={`${document_0.kind}-${document_0.completedVersion}`} />;
      $[29] = entity;
      $[30] = t14;
    } else {
      t14 = $[30];
    }
    t13 = documents.map(t14);
    $[26] = documents;
    $[27] = entity;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[31] !== t13) {
    t14 = <div className="flex flex-col h-full gap-3 p-4">{t13}</div>;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t12 || $[34] !== t14 || $[35] !== t7) {
    t15 = <fieldset aria-label={t7} className="flex flex-col justify-between w-full h-full border border-solid rounded border-tertiary" id={DOCUMENTS_ID}>{t12}{t14}</fieldset>;
    $[33] = t12;
    $[34] = t14;
    $[35] = t7;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};
export default DocumentFieldset;
function _temp(resolve) {
  return setTimeout(resolve, 0);
}
function _temp2() {
  return new Promise(_temp);
}
function _temp3($) {
  return $.documents.title;
}
function _temp4($_0) {
  return $_0.documents.title;
}
function _temp5($_1) {
  return $_1.deselectAll;
}
function _temp6($_2) {
  return $_2.selectAll;
}